export const AppMain = {
  home: 'Home',
  about: 'About',
};
